import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dimmer, Loader, Modal } from 'semantic-ui-react';

import { getParticipantsList } from '../../../../../../api/nora/programs';

import useForm from '../../../../../../hooks/useForm';

import { useUIAction } from '../../../../../../contexts/UIContext';
import { useProgramState } from '../../../../../../contexts/ProgramsContext';

import FormSelect from '../../../../../Form/FormSelect';
import { mapLookupTypes } from '../../../../../../services/utils';

const AgencySearchModal = ( {
	closeModal,
	onSearch,
	open,
	setFilter
} ) => {
	const { program } = useProgramState();
	const { setApiErrorAlert } = useUIAction();

	const [ isLoading, setIsLoading ] = useState( false );
	const [ searchLoading, setSearchLoading ] = useState( false );
	const [ agencies, setAgencies ] = useState( [] );

	const { formData, updateField, setFormData } = useForm( {} );

	useEffect( () => {
		( async () => {
			setIsLoading( true );

			try {
				const data = await getParticipantsList( program.id );

				setAgencies( mapLookupTypes( data ) );
			} catch ( error ) {
				setApiErrorAlert( error );
			}

			setIsLoading( false );
		} )();
	}, [
		program.id,
		setApiErrorAlert
	] );

	const handleClose = useCallback( () => {
		setFormData( {} );
		closeModal();
	}, [
		closeModal,
		setFormData
	] );

	const handleSearch = useCallback( async () => {
		setSearchLoading( true );
		await onSearch( formData.agency );

		const agency = agencies
			.find( ( { value } ) => value === formData.agency )
			?.text;

		setFilter( <span>Showing the status of all submissions from <strong>{ agency }</strong></span> );

		setFormData( {} );
		setSearchLoading( false );
		closeModal();
	}, [
		agencies,
		closeModal,
		formData.agency,
		onSearch,
		setFilter,
		setFormData
	] );

	return (
		<Modal
			open={ open }
			size="tiny"
		>
			<Modal.Header>Search By Agency</Modal.Header>
			<Modal.Content>
				<Dimmer
					active={ isLoading }
					inverted
					style={{ borderRadius: 0 }}
				>
					<Loader inverted />
				</Dimmer>
				<FormSelect
					fieldLabel="Agency"
					name="agency"
					onChange={ updateField }
					options={ agencies }
					value={ formData.agency }
					width={ 8 }
				/>
			</Modal.Content>
			<Modal.Actions>
				<Button
					content="Search"
					disabled={ !formData.agency }
					loading={ searchLoading }
					onClick={ handleSearch }
				/>
				<Button
					content="Cancel"
					onClick={ handleClose }
				/>
			</Modal.Actions>
		</Modal>
	);
};

AgencySearchModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	onSearch: PropTypes.func.isRequired,
	open: PropTypes.bool,
	setFilter: PropTypes.func.isRequired
};

export default AgencySearchModal;
